import { Box, Typography, Chip, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

function HomePage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const skills = [
    "Data Science", "Natural Language Processing", "Large Language Models",
    "Recommender Systems", "Python",
    "Mentoring", "Teaching",
  ];
  const [time, setTime] = useState("");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(
        now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata",
        })
      );
    };
    updateTime();
    const intervalId = setInterval(updateTime, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      sx={{
        maxWidth: 700,
        mx: "auto",
        textAlign: "center",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(20px)",
        transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontSize: { xs: "2rem", md: "2.5rem" },
          mb: 2,
        }}
      >
        Hello, there! 👋
      </Typography>

      <Box
        component="img"
        src="Profile pic1.jpg"
        alt="Profile"
        sx={{
          width: { xs: 180, md: 220 },
          height: { xs: 180, md: 220 },
          aspectRatio: "1",
          borderRadius: "50%",
          mx: "auto",
          display: "block",
          objectFit: "cover",
          mb: 4,
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.25 }}
      >
        <span>Based in India 🇮🇳 | {time}</span>
      </motion.div>

      <Stack
        spacing={1.5}
        sx={{
          mt: 3,
          maxWidth: 700,
          mx: "auto",
          fontSize: { xs: "1rem", md: "1.1rem" },
          lineHeight: 1.8,
          color: "rgba(255, 255, 255, 0.8)",
          mb: 4,
        }}
      >
        <Typography component="p" sx={{ color: "inherit", fontSize: "inherit", lineHeight: "inherit" }}>
          Hi, I&apos;m{" "}
          <Box
            component="span"
            sx={{ fontWeight: 700, color: "#f5576c", fontSize: "1.1em" }}
          >
            Thirupathi Thangavel
          </Box>{" "}
          (Thiru).
        </Typography>

        <Typography component="p" sx={{ color: "inherit", fontSize: "inherit", lineHeight: "inherit" }}>
          I&apos;m a former Machine Learning Engineer at{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            Google
          </Box>
          .
        </Typography>

        <Typography component="p" sx={{ color: "inherit", fontSize: "inherit", lineHeight: "inherit" }}>
          I specialize in{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            NLP
          </Box>{" "}
          and building{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            AI
          </Box>
          -powered solutions.
        </Typography>
      </Stack>

      <Box
        sx={{
          background: "rgba(255, 255, 255, 0.03)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "20px",
          padding: { xs: 2.5, md: 3 },
          maxWidth: 700,
          mx: "auto",
          mb: 4,
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-5px)",
            borderColor: "rgba(102, 126, 234, 0.3)",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.9)",
            fontSize: { xs: "0.95rem", md: "1.05rem" },
            lineHeight: 1.7,
          }}
        >
          I also enjoy teaching and mentoring, having guided{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {" "}
            200+{" "}
          </Box>{" "}
          students and professionals through data science courses and career
          guidance.
        </Typography>
      </Box>

      <Box sx={{ mt: 4 }}>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            mb: 2.5,
            fontWeight: 600,
            color: "rgba(255, 255, 255, 0.9)",
            fontSize: { xs: "1rem", md: "1.1rem" },
          }}
        >
          Core Expertise
        </Typography>
        <Stack
          direction="row"
          spacing={1.5}
          flexWrap="wrap"
          justifyContent="center"
          sx={{ gap: 1.5 }}
        >
          {skills.map((skill, index) => (
            <Chip
              key={skill}
              label={skill}
              sx={{
                background: "rgba(102, 126, 234, 0.1)",
                border: "1px solid rgba(102, 126, 234, 0.3)",
                color: "rgba(255, 255, 255, 0.9)",
                fontWeight: 500,
                fontSize: { xs: "0.85rem", md: "0.9rem" },
                padding: { xs: "4px 8px", md: "6px 12px" },
                height: "auto",
                transition: "all 0.3s ease",
                animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
                "&:hover": {
                  background: "rgba(102, 126, 234, 0.2)",
                  borderColor: "rgba(102, 126, 234, 0.5)",
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 20px rgba(102, 126, 234, 0.2)",
                },
                "@keyframes fadeInUp": {
                  from: {
                    opacity: 0,
                    transform: "translateY(20px)",
                  },
                  to: {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                },
              }}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
}

export default HomePage;
